exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden_header{display:none}#table-contents ul ul a{font-size:16px!important;padding-left:0!important;background:#e9ecef}#table-contents ul ul a:hover{text-decoration:underline}li.doc{font-size:20px!important;li{font-size:16px!important}}hr{background-color:#000}", ""]);

// exports
